import React from 'react';
import { TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

interface ICustomDateTime {
    label?: string;
    inputProps: any;
    onChange(newDate: any): void;
    value: any;
}

function CustomDateTime(props: ICustomDateTime) {
    const { label, inputProps, onChange, value, ...rest } = props;

    const InputProps = {
        ...inputProps,
        className: 'custom-date-time-input',
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
                {...rest}
                label={label}
                value={value}
                onChange={(newDate) => onChange(newDate)}
                InputProps={InputProps}
                renderInput={(params) => <TextField {...params} size="small" />}
            />
        </LocalizationProvider>
    );
}

export default CustomDateTime;